import { z } from 'zod';

export const EmailStepSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter a valid email'),
});

export type EmailStepValues = z.infer<typeof EmailStepSchema>;

export const ResetStepSchema = z
  .object({
    code: z
      .string()
      .min(6, 'Enter the 6-digit code')
      .max(6, 'Enter the 6-digit code')
      .regex(/^\d{6}$/, 'Code must be 6 digits'),
    newPassword: z.string().min(8, 'Password must be at least 8 characters'),
    confirmPassword: z.string().min(1, 'Confirm your new password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type ResetStepValues = z.infer<typeof ResetStepSchema>;
